






































import { Component, Vue } from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import Avatar from '@/components/Avatar.vue';
import CounterBox from '@/components/sidebar/CounterBox.vue';
import { ICoursesCounters } from '../../types/types';
import { default as egText } from '../../directives/text';

@Component({
  components: { CounterBox, Avatar, Icon },
  directives: { egText }
})
export default class Sidebar extends Vue {
  activeIcon = require('../../assets/images/svg/active.svg');

  completedIcon = require('../../assets/images/svg/completed.svg');

  allIcon = require('../../assets/images/svg/all.svg');

  get counters() {
    const counters: ICoursesCounters = this.$store.getters['courses/counters'];
    return {
      active: { counter: counters.active, text: `${this.$t('activeCourses')}` },
      completed: { counter: counters.completed, text: `${this.$t('completedCourses')}` },
      all: { counter: counters.all, text: `${this.$t('allCourses')}` }
    };
  }

  get user() {
    return this.$store.getters['user/user'];
  }
}
